
import {defineComponent} from "vue";
import {useMapStore} from "@/mixins/mapStore";
import DataViewer from "@/components/DataViewer.vue"
export default defineComponent(
    {
      name: "DataViewerContainer",
      components: {DataViewer},
      setup(props){
       return {
         mapStore: useMapStore()
       }
      }
    }
)
